import { Grid } from '@mui/material';
import { memo, useMemo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { AccordionGeneralityFormVM } from 'front-office/view-models/certificate/generality-form';
import { DocumentRadioCertificate } from 'front-office/constants/document-radio-certificate';

interface IdentityCardProps {
  generality?: AccordionGeneralityFormVM;
  onFieldGeneralityChange: (
    key: keyof AccordionGeneralityFormVM,
    value: AccordionGeneralityFormVM[keyof AccordionGeneralityFormVM]
  ) => void;
}

const IdentityCardComponent = ({
  onFieldGeneralityChange,
  generality,
}: IdentityCardProps): React.ReactElement => {
  const documentString = useMemo(() => {
    let cartaIdentitaComuneRilascio = '';

    if (generality?.isForeignDocument === DocumentRadioCertificate.Other) {
      cartaIdentitaComuneRilascio = generality?.consulateCode || '';
    } else if (generality?.isForeignDocument === DocumentRadioCertificate.IdentityCard) {
      cartaIdentitaComuneRilascio =
        `Comune di ${generality?.municipalityDocument?.description}` || '';
    }

    let numeroCarta = generality?.numberDocument || '';

    if (
      generality?.isFromAnpr &&
      generality?.numberDocument &&
      generality?.isForeignDocument === DocumentRadioCertificate.IdentityCard
    ) {
      numeroCarta = `Carta d'identità n.${generality?.numberDocument || ''}`;
    }

    return `${numeroCarta || ''} rilasciato il ${
      generality?.dateReleaseDocument ? generality?.dateReleaseDocument?.toFormat('dd/MM/yyyy') : ''
    } da ${cartaIdentitaComuneRilascio}`;
  }, [generality]);

  return generality?.isForeignDocument === DocumentRadioCertificate.Witness ? (
    <></>
  ) : (
    <Grid container item spacing={2}>
      <Grid item xs={12}>
        <PmiTextField
          label="Documento"
          aria-label="Documento"
          id="number-document"
          fullWidth
          onChange={(event) => {
            onFieldGeneralityChange('documentString', event?.target.value);
          }}
          disabled
          value={documentString || ''}
        />
      </Grid>
    </Grid>
  );
};

IdentityCardComponent.displayName = 'Shared identity card component';

const IdentityCard = memo(IdentityCardComponent);

export default IdentityCard;
